import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app-style-four',
  templateUrl: './download-app-style-four.component.html',
  styleUrls: ['./download-app-style-four.component.scss']
})
export class DownloadAppStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
